import { Conversation } from "@twilio/conversations";
import { Dispatch } from "redux";

import { ACTION_UPDATE_CONVERSATION_STATE, ACTION_UPDATE_AWAITING_BOT, ACTION_UPDATE_HUMAN_MODE } from "../actionTypes";

export const initConversationListener = (conversation: Conversation, dispatch: Dispatch) => {
    conversation.addListener("updated", ({ conversation: updatedConversation, updateReasons }) => {
        // we are listening only to a subset of events.
        if (updateReasons?.includes("state")) {
            dispatch({
                type: ACTION_UPDATE_CONVERSATION_STATE,
                payload: { conversationState: updatedConversation?.state?.current }
            });
        }

        /*
         * The backend drives the "waiting for bot" state via conversation.attributes.botTyping
         * (true while generating, false when done). We only react when the botTyping KEY is
         * present, so unrelated attribute updates (e.g. taskSid) never release the lock by mistake.
         */
        if (updateReasons?.includes("attributes")) {
            const attributes = (updatedConversation?.attributes ?? {}) as Record<string, unknown>;
            if (Object.prototype.hasOwnProperty.call(attributes, "botTyping")) {
                dispatch({
                    type: ACTION_UPDATE_AWAITING_BOT,
                    payload: { awaitingBot: attributes.botTyping === true }
                });
            }
            /*
             * Transbordo: o synccx-api carimba handoff=true (+ botTyping=false). A partir daí
             * é modo humano — o widget para de mostrar balão e de travar o input.
             */
            if (attributes.handoff === true) {
                dispatch({
                    type: ACTION_UPDATE_HUMAN_MODE,
                    payload: { humanMode: true }
                });
            }
        }
    });
};
